const { getOffsetTop } = window.BAO.Utils

class StickyScroll extends window.BAO.CustomElement() {
  connectedCallback () {
    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onResize = this.onResize.bind(this)
    this.checkAndUpdate = this.checkAndUpdate.bind(this)
    this.clearStickyStyles = this.clearStickyStyles.bind(this)

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.scrollDirection = ''
    this.scrollDirectionPrevious = ''
    this.resizeTimeout = null

    super.connectedCallback()
    this.checkAndUpdate()
  }

  setupListeners () {
    super.setupListeners()

    this.onScroll = this.onScroll.bind(this)

    this.listeners.add(window, 'scroll', this.onScroll)
    this.listeners.add(window, 'resize', this.onResize)
  }

  get isDesktop () {
    return window.matchMedia('(min-width: 901px)').matches
  }

  onResize () {
    if (this.resizeTimeout) {
      clearTimeout(this.resizeTimeout)
    }

    this.resizeTimeout = setTimeout(() => {
      this.checkAndUpdate()
    }, 150)
  }

  checkAndUpdate () {
    if (!this.isDesktop) {

      this.clearStickyStyles()
      return
    }

    this.updateEl()
  }

  clearStickyStyles () {
    if (!this.els.container || !this.els.content || !this.els.spacer) return

    this.classList.remove('prd-Detail_Columns-defaultSticky')
    this.els.content.element.removeAttribute('style')
    this.els.spacer.element.removeAttribute('style')
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY
    this.scrollDirectionPrevious = this.scrollDirection

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    if (!this.isDesktop) return

    this.setSticky()
  }

  setSticky () {
    if (!this.els.container || !this.els.content || !this.els.spacer) return

    const containerHeight = this.els.container.element.offsetHeight
    const contentHeight = this.els.content.element.offsetHeight
    const viewportHeight = window.innerHeight

    // Check if we need custom sticky behaviour
    // Conditions: container is taller than content AND content is taller than viewport
    if (containerHeight > contentHeight && viewportHeight < contentHeight) {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', false)

      const offsetAmount = viewportHeight - contentHeight

      // When scroll direction changes, recalculate spacer margin
      if (this.scrollDirectionPrevious !== this.scrollDirection) {
        const containerOffsetTop = getOffsetTop(this.els.container.element)
        const contentOffsetTop = getOffsetTop(this.els.content.element)

        const marginTop = contentOffsetTop - containerOffsetTop
        this.els.spacer.element.style.setProperty('margin-top', `${marginTop}px`)
      }

      if (this.scrollDirection === 'down') {
        this.els.content.element.style.setProperty('top', `${offsetAmount}px`)
        this.els.content.element.style.removeProperty('bottom')
      } else {
        if (document.body.classList.contains('lyt-Site-headerVisible')) {
          this.els.content.element.style.setProperty(
            'bottom',
            `calc(${offsetAmount}px - var(--Header_Height))`
          )
        } else {
          this.els.content.element.style.setProperty('bottom', `${offsetAmount}px`)
        }

        this.els.content.element.style.removeProperty('margin-top')
      }
    } else {
      this.classList.toggle('prd-Detail_Columns-defaultSticky', true)
      this.els.content.element.style.removeProperty('top')
      this.els.content.element.style.removeProperty('bottom')
      this.els.spacer.element.style.removeProperty('top')
    }
  }
}

if (!customElements.get('sticky-scroll')) {
  customElements.define('sticky-scroll', StickyScroll)
}
